export default {
  spanish: '西班牙语',
  english: '英语',
  addPrinter: {
    title: "添加打印机",
    detectPrinters: "自动检测打印机",
    printerName: "打印机名称",
    printerType: "打印机类型",
    laser: "激光打印机",
    receipt: "收据打印机",
    barcode: "条码打印机",
    connectionType: "连接类型",
    network: "网络",
    ipAddress: "IP地址",
    port: "端口",
    driverType: "驱动程序类型",
    printSpeed: "打印速度",
    autoCutter: "自动切纸",
    cashDrawerPort: "钱箱端口",
    printDensity: "打印浓度",
    savePrinter: "保存打印机",
    detectionCompleted: "打印机检测完成。",
    fillAllFields: "请填写所有必填字段。",
    success: "打印机添加成功！",
    scanning: "正在搜索打印机...",
    detectionSuccess: "成功检测到打印机！",
    noPrintersFound: "未找到打印机。",
    detectionError: "检测打印机时出错。"
  },
  // 可以在此处添加更多翻译
  backoffice: {
    printerManager: {
      title: "打印机管理",
      printers: "打印机",
      select: "选择",
      discoverPrinters: "发现打印机",
      showAddPrinter: "添加打印机",
      printTest: "打印测试页",
      scanBluetooth: "扫描蓝牙打印机",
      printerName: "打印机名称",
      printerType: "打印机类型",
      laser: "激光打印机 (A4)",
      receipt: "收据打印机",
      barcode: "条码打印机",
      autoCutter: "自动切刀",
      driverType: "驱动类型",
      connectionType: "连接类型",
      ipAddress: "IP地址",
      port: "端口",
      mac: "MAC地址",
      isDefault: "默认",
      add: "[ZH] Add",
      cancel: "取消",
      noPrintersFound: "未找到打印机。",
      printSentSuccess: "已成功发送到网络打印机。",
      printFailedBackend: "后端打印失败。",
      networkPrintError: "网络打印错误：{error}",
      usbPrintError: "USB打印错误。请检查连接！",
      noUSBPrinters: "未检测到USB打印机！",
      bluetoothPrintError: "蓝牙打印错误。请检查连接！",
      printFailed: "打印失败。请检查打印机连接并重试。",
      selectPrinterType: "选择 Printer Connection Type",
      inputPlaceholder: "选择 a type connection",
      pleaseSelectPrinterType: "请选择打印机类型。",
      invalidPrinterType: "选择了无效的打印机类型。",
      scannedFromBLE: "从BLE扫描：{barcode}"
    },
    bleScanner: {
      title: "BLE扫描仪和打印机",
      deviceType: "设备类型",
      scanner: "条码扫描仪",
      printer: "打印机",
      scanDevices: "扫描BLE设备",
      unnamedDevice: "未命名设备",
      connect: "[ZH] Connect",
      scannedBarcode: "扫描条码：",
      printData: "打印数据",
      enterPrintText: "输入要打印的文本",
      sendToPrinter: "发送到打印机",
      bleScanError: "BLE扫描错误：{error}",
      connectionSuccess: "已连接到 {device}",
      connectionError: "连接错误：{error}",
      notificationError: "通知错误：{error}",
      scanned: "已扫描：{barcode}",
      noPrinterOrData: "未连接打印机或打印数据为空。",
      printDataSent: "打印数据已发送到打印机。",
      printError: "打印错误：{error}"
    },
    interactions: {
      lastContacted: '最后联系',
      notesLastContacted: '最后联系备注',
      nextFollowUp: '下次跟进',
      notesNextFollowUp: '下次跟进备注',
      preferredContactTime: '首选联系时间',
      notesContactToTime: '首选联系时间备注',
      selectSubscriber: '选择订阅者',
      selectSubscriberDescription: '选择一个订阅者以添加或查看其信息',
      selectSubscriberInput: '选择一个订阅者',
      selectSubscriberInputPlaceholder: '选择一个订阅者',
      createSubscriber: '创建订阅者',
      cancel: '取消',
      //customers
      selectCustomer: '选择客户',
      selectCustomerDescription: '选择一个客户以添加或查看其信息',
      selectCustomerInput: '选择一个客户',
      selectCustomerInputPlaceholder: '选择一个客户',
      createCustomer: '创建客户',
    },
    cCardSaved:{
      paymentManagement: '付款管理',
      clickToManageCards: '点击此处添加或查看您存档的卡片',
      creditCards: '信用卡',
      addCreditCard: '添加信用卡',
    },
    virtualTerminal: {
      acordeon1: {
        title: '付款/授权信息',
        subtitle: '接受的支付方式: 美国运通、Discover、万事达卡',
        cardNumber: '卡号',
        expirationDate: '有效期',
        amount: '金额'
      },
      acordeon2: {
        title: '订单信息',
        subscriptionName: '订阅名称',
        invoice: '发票号',
        description: '描述',
        placeholder: '在此输入更多信息...'
      },
      acordeon3: {
        title: '订阅周期',
        subtitle: '选择客户账单频率',
        selectOption: '选择选项',
        interval1: '每月',
        interval2: '每季度',
        interval3: '每半年',
        interval4: '每年'
      },
      acordeon4: {
        title: '订阅期限',
        startDate: '开始日期',
        noEnd: '无结束日期（持续订阅）',
        endDate: '结束日期',
        endAfter: '在...之后结束'
      },
      acordeon5: {
        title: '付款',
        nameAcount: '账户姓名',
        paymentType: '付款类型',
        creditCard: '信用卡',
        subscriptionName: '订阅名称',
        trialAmount: '试用金额',
        firstName: '名字',
        sameAsBilling: '与账单地址相同'
      }
    },
    worksheetStatus: {
      draft: '草稿',
      opened: '已打开',
      closed: '已关闭',
      worksheetDetail: '工作表详情',
      fields: {
        responsable: '负责人',
        startDate: '开始日期',
        endDate: '结束日期',
        workers: '工作人员'
      },
      tooltip: {
        staffWorker: '添加工作人员',
        resetAllCalendar: '重置所有日历',
        showCalendarDetails: '显示日历详情',
        resetCalendar: '重置此日历',
        removeStaffWorker: '移除工作人员',
        debit: '这些是您的支出。支付出去的款项。',
        credit: '这些是您的收入。收到的款项。',
        payee: '这是您付款或收款的对象。',
        category: '这是付款或信贷的类型。',
        bestRepresentation: '这是系统对类别的最佳猜测。'
      },
      message: {
        totalHour: '总工作时间：',
        hours: '小时',
        with: '和',
        minutes: '分钟',
        typeMessage: '在此输入消息...'
      },
      button: {
        saveDraft: '保存草稿',
        saveOpen: '保存并打开',
        close: '关闭',
        addShift: '添加班次',
        changeworksheetRequest: '变更请求'
      }
    },
    mastercard:{
      accountInfo: '账户信息',
      mastercardUserDetails: '万事达卡用户详情',
      seeLinedAccounts: '查看关联账户',
      addMoreBanks: '添加更多银行',
      linkedBanks: '关联账户',
      viewTransactions: '查看交易',
      linesPerPage: '每页行数',
    },
    transactionData: {
      revenue: "收入",
      revenueDescription: "如果此交易是收入条目，请切换此开关。",
      transactionId: "交易ID",
      transactionIdDescription: "输入与此交易关联的唯一交易ID。",
      transactionAmount: "交易金额（美元）",
      transactionAmountDescription: "输入以美元计的交易金额。这是交易涉及的金额。",
      accountId: "账户ID",
      accountIdDescription: "输入与交易关联的唯一账户ID。",
      customerId: "客户ID",
      customerIdDescription: "输入与交易关联的唯一客户ID。",
      transactionStatus: "交易状态",
      transactionStatusDescription: "从可用选项中选择交易的当前状态。",
      statusOptions: {
        active: "活跃",
        pending: "待处理",
        completed: "已完成",
        failed: "失败",
        cancelled: "已取消"
      },
      memo: "备忘录",
      memoDescription: "输入交易的任何附加说明或备忘录。",
      transactionType: "交易类型",
      transactionTypeDescription: "选择此交易的交易类型。",
      transactionDate: "交易日期",
      transactionDateDescription: "选择交易发生的日期。",
      typeOptions: {
        debit: "借记",
        credit: "贷记",
        transfer: "转账",
        payment: "付款",
        withdrawal: "取款",
        deposit: "存款"
      },
      postedDate: "过账日期",
      postedDateDescription: "选择交易过账的日期。",
      createdDate: "创建日期",
      createdDateDescription: "选择交易创建的日期。",
      firstEffectiveDate: "首次生效日期",
      firstEffectiveDateDescription: "选择交易的首次生效日期。",
      effectiveDate: "生效日期",
      effectiveDateDescription: "选择交易的生效日期。",
      optionExpireDate: "期权到期日期",
      optionExpireDateDescription: "如适用，选择期权到期日期。",
      checkNumber: "支票号码",
      checkNumberDescription: "如适用，输入支票号码。如不适用则留空。",
      escrowAmount: "托管金额（美元）",
      escrowAmountDescription: "如适用，输入托管金额。这是为交易保留的托管金额。",
      transactionFeeAmount: "交易手续费金额（美元）",
      transactionFeeAmountDescription: "如适用，输入手续费金额。这是处理交易收取的费用。",
      suspenseAmount: "暂记金额（美元）",
      suspenseAmountDescription: "如适用，输入暂记金额。用于暂时保留或待处理的交易。",
      interestAmount: "利息金额（美元）",
      interestAmountDescription: "如适用，输入利息金额。这是交易产生的利息金额。",
      principalAmount: "本金金额（美元）",
      principalAmountDescription: "如适用，输入本金金额。这是借入或投资的原始金额，不包括任何利息或费用。",
      optionStrikePrice: "期权行权价（美元）",
      optionStrikePriceDescription: "如适用，输入期权行权价。这是可以行使期权的价格。",
      unitQuantity: "单位数量",
      unitQuantityDescription: "如适用，输入单位数量。这是交易涉及的单位数量，如购买的商品或交易的股票。",
      unitPrice: "单价（美元）",
      unitPriceDescription: "如适用，输入单价。用于涉及证券或投资的交易。",
      transactionCategorization: "交易分类",
      normalizedPayeeName: "标准化收款人名称",
      normalizedPayeeNameDescription: "以标准化格式输入收款人名称。这有助于确保记录的一致性。",
      transactionCategory: "交易类别",
      transactionCategoryDescription: "输入交易类别，如'销售'、'采购'或'转账'。",
      customCategory: "自定义类别",
      customCategoryDescription: "如适用，输入自定义类别。适用于不符合预定义类别的交易。",
      city: "城市",
      cityDescription: "输入与交易相关的城市。",
      state: "州/省",
      stateDescription: "输入交易发生的州或地区。",
      postalCode: "邮政编码",
      postalCodeDescription: "输入与交易关联地点的邮政编码。",
      country: "国家",
      countryDescription: "输入交易发生的国家。",
      bestRepresentation: "最佳表示",
      bestRepresentationDescription: "输入交易的最佳表示，可以是通用描述或分类。",
      runningBalanceAmountUSD: "运行余额金额（美元）",
      runningBalanceAmountUSDDescription: "输入以美元计的运行余额金额，这是交易处理后的持续余额。",
      subaccountSecurityType: "子账户证券类型",
      subaccountSecurityTypeDescription: "如适用，输入与子账户关联的证券类型。",
      commissionAmountUSD: "佣金金额（美元）",
      commissionAmountUSDDescription: "如适用，输入以美元计的佣金金额。这是交易收取的费用。",
      tickerSymbol: "股票代码",
      tickerSymbolDescription: "输入交易涉及的资产或证券的股票代码。",
      investmentTransactionType: "投资交易类型",
      investmentTransactionTypeDescription: "输入投资交易类型，如'买入'、'卖出'或'股息'。",
      taxesAmountUSD: "税款金额（美元）",
      taxesAmountUSDDescription: "输入与交易相关的税款金额，以美元计。",
      currencySymbol: "货币符号",
      currencySymbolDescription: "输入交易使用的货币符号，如'$'代表美元或'€'代表欧元。",
      incomeType: "收入类型",
      incomeTypeDescription: "输入收入类型，如'工资'、'利息'或'资本收益'。",
      splitDenominator: "拆分分母",
      splitDenominatorDescription: "如适用，输入任何分数或拆分交易的分母。",
      splitNumerator: "拆分分子",
      splitNumeratorDescription: "如适用，输入拆分分子。此值用于涉及跨多个类别或账户拆分金额的交易。",
      sharesPerContract: "每合约股数",
      sharesPerContractDescription: "如适用，输入每合约股数。这与涉及股票的投资交易或合约相关。",        
      subAccountFund: "子账户资金",
      subAccountFundDescription: "如适用，输入子账户资金。",        
      securityId: "证券ID",
      securityIdDescription: "如适用, 输入证券ID。",        
      securityIdType: "证券ID类型",
      securityIdTypeDescription: "如适用, 输入证券ID类型。",
      saveTransaction: "保存交易"
    },
    multiActionText: {
      selectAll: '全选',
      deselectAll: '取消全选',
      deleteSelected: '删除所选',
    },
    communicationResponse: {
      failedToLoad: '加载失败',
      emailError: '无法获取邮件回复，请稍后再试。',
      smsError: '无法获取短信回复，请稍后再试。',
    },
    interactionHistory: {
      historyInteraction: "历史互动",
      lastContacted: "最后联系时间",
      notesLastContacted: "备注",
      nextFollowUp: "下次跟进",
      notesNextFollowUp: "备注",
      preferredContactTime: "首选联系时间",
      preferredContactToTime: "至",
      notesContactToTime: "备注",
      noHistory: "无历史记录"
    },    
    imenuPayFlex:{
      invoiceId: "发票编号",
      planName: "计划名称",
      amount: "金额",
      totalAmount: "总金额",
      subscription: "订阅",
      schedulePayment: "付款计划",
      recurringPayment: "定期付款？",
      frequency: "频率",
      payEvery: "每",
      customInterval: "自定义间隔",
      customIntervalNote: "每 {days} 天付款一次",
      payStartsOn: "付款开始日期",
      payUntil: "付款截止日期",
      endsAfterDate: "付款结束日期",
      endsAfterOccurrences: "付款在 {count} 次后结束",
      howToPay: "您想如何付款？",
      creditCard: "信用卡",
      banking: "银行转账",
      placeholderCustomInterval: "2",
      placeholderOccurrences: "例如：2",
    },
    googleCalendar: {
      createEvent: "创建活动",
      title: "标题",
      description: "描述",
      location: "地点",
      startTime: "开始时间",
      endTime: "结束时间",
      timeZone: "时区",
      selectTimeZone: "选择时区",
      attendeeEmail: "参与者邮箱",
      attendeeEmailPlaceholder: "client@example.com",
      attendeeEmailLabel: "参与者邮箱",
      addAttendee: "添加参与者",
      providerEmail: "提供商邮箱",
      providerEmailPlaceholder: "provider@example.com",
      color: "颜色",
      selectColor: "选择颜色",
      submitEvent: "创建活动",
      updateEvent: "更新活动",
      upcomingEvents: "即将举行的活动",
      deleteConfirmationTitle: "确定吗？",
      deleteConfirmationText: "此操作无法撤销！",
      deleteNotificationCheckbox: "是否通知参与者活动已取消？",
      deleteConfirmButton: "确认删除",
      deleteCancelButton: "取消",
      deleteSuccessTitle: "已删除！",
      deleteSuccessText: "活动已删除。",
      deleteErrorTitle: "错误！",
      deleteErrorText: "无法删除活动。"
    },        
    bulkSend: {
      title: "什么是批量发送？",
      text: "批量发送功能可让您同时发送多封邮件和短信，提高沟通效率。",
      confirmButtonText: "明白了！",
      selectRecipientsTitle: "选择收件人",
      selectAllCustomers: "选择所有客户",
      selectAllSubscribers: "选择所有订阅者",
      bulkSendOptionsTitle: "批量发送选项",
      sendEmail: "发送批量邮件",
      sendSMS: "发送批量短信",
      whenToSend: "您希望何时发送？",
      sendNow: "立即发送",
      schedule: "定时发送",
      cancel: "取消",
      validationSelectMethod: "请至少选择一种发送方式。",
      validationScheduledTime: "定时发送时间必须晚于当前时间。",
      successSent: "发送成功！",
      successScheduled: "定时发送设置成功！",
      error: "发生错误。",
      subject: "批量通知",
      body: "您的定时消息内容将显示在此处。",
      bulkSend:"批量发送",
      validationSelectRecipients: "请至少选择一位收件人"
    },      
    table: {
      transactionDate: '交易日期',
      customerId: '客户编号',
      status: '状态',
      debit: '借记',
      credit: '贷记',
      description: '描述',
      memo: '备注',
      payee: '收款人',
      category: '类别',
      bestRepresentation: '最佳代表',
      country: '国家',
      action: '操作'
    },
    emailTest: {
      sendTest: '发送测试邮件',
      message: "这是一条示例消息，请勿回复。",
      subject: 'iMenuApps® 支持',
      success: '邮件发送成功。'
    },
    menu: {
      transactionData: '交易数据',
      bankAccountConnection: '银行账户连接',
      viewTransactions: '查看交易',
      validationPhone: '电话号码必须为 10 位数字。',
      restaurantAdministration: '管理',
      savedSuccesful: '设置更改成功',
      savedFailed: '保存设置时出错。',
      lostChanges: '离开此页面将丢失您的更改！',
      sure: '确定吗？',
      wontRevert: "此操作无法撤销！",
      yesVoid: '确认作废付款！',
      voided: '已作废！',
      voidedSuccessfully: '付款已成功作废。',
      yesRefund: '确认退款！',
      refund: '已退款！',
      refundSuccessfully: '退款处理成功。',
      merchantQuoteNotes: '商家报价备注',
      merchantInvoiceNotes: '商家发票备注',
      titleInformationIncomplete: '必填信息',
      informationIncomplete: '请填写所有必填字段。',
      yes: '是',
      emailSend: '邮件已发送',
      emailSendTo: '发票邮件已成功发送至',
      questionSendEmail: '发送邮件？',
      dialogSendEmail: '确认发送邮件至',
      addNewSendEmail: '添加其他邮箱地址',
      send: '发送',
      close: '关闭',
      alertEmailSend: '邮件已发送',
      alertEmailSendTo: '成功发送至',
      session: '会话',
      foodServices: '产品/服务',
      ordersTickets: '订单/票据',
      reservationsDeliveries: '预订/配送',
      restaurantAdministration: '管理',
      report: '报告',
      sales: '销售',
      staffOccupationsCustomersDrivers: '员工/职位/客户/司机',
      marketing: '营销',
      settings: '设置',
      merchantSettings: '商家设置',
      revenue: '收入',
      revenueInfo: 'iMenuApps® 的收入模块是您管理业务所有收入活动的中心枢纽。此模块可让您高效处理与收入和财务交易相关的各种任务，确保业务运营顺畅且盈利。以下是收入模块的功能：1. 查看/创建订单：从创建到完成管理客户订单。此功能可让您跟踪所有订单，确保它们得到处理。2. 预订：管理并跟踪服务预订，无论是餐饮、活动还是其他预订。此功能确保您能有效管理预订并避免超额预订。3. 报价：为潜在收入创建和管理报价，让您在最终销售前为客户提供详细的定价和服务信息。轻松将接受的报价转换为发票以简化收入流程。4. 发票：生成、管理和跟踪所有客户发票。此功能确保准确计费并提供所有收入交易的清晰记录。5. 配送：协调和管理订单的配送详情，包括准备、安排和发货。6. 跟踪配送：实时监控配送状态和进度，确保您的配送按计划进行并让客户随时了解情况。7. 订阅账单：管理订阅服务的定期账单，确保客户按时准确支付持续服务费用。8. 配送：监督和管理所有配送活动，从订单履行到最终交付给客户，确保商品和服务高效送达目的地。9. 取货请求：处理客户的订单取货请求，让他们直接从您的营业地点取货。',
      adminInfo: 'iMenuApps® 的管理模块是管理业务各种运营和后勤方面的控制中心。以下是此模块的功能和任务概述：1. 餐桌管理：配置和管理业务的餐桌设置，包括餐桌数量、排列和座位容量。优化预订空间并确保高效的餐桌周转。2. 税务管理：设置和管理适用于您所选项目和服务的税率。确保根据当地法规准确应用所有交易的税费。3. 配送管理：从分配到完成监督您的配送运营。实时跟踪订单并向客户提供配送更新。确保高效及时的配送服务以提高客户满意度。4. 员工管理：管理您的员工团队，包括添加新员工、更新角色和管理权限。设置角色并分配任务以确保运营顺畅。5. 司机管理：管理您的配送司机，分配配送任务并跟踪他们的表现。确保您的配送服务顺畅高效运行。6. 权限角色：定义和管理员工和管理员的角色和权限。确保每位团队成员都能访问他们履行职责所需的工具和信息。7. 工作表管理：跟踪和管理员工的工作时间和排班。确保准确的考勤和薪资处理。8. 职位管理：组织和管理业务内的不同员工职位。保持团队结构清晰和角色明确。9. 客户管理：管理客户信息、跟踪订单并维护客户档案。通过轻松访问所有客户详情来提升客户服务。10. 信用管理：高效处理客户信用，将信用应用于订单并跟踪信用余额。11. 菜单管理：设计和管理的业务菜单，包括创建新菜单、更新项目和定价。12. 类别管理：将菜单项目组织到类别中以便于导航和管理。保持菜单结构清晰，方便客户浏览。13. 产品管理：管理您的产品库存，包括添加新项目、更新现有项目和管理库存水平。14. 条码生成器：为您的产品创建和管理条码以简化库存管理和收入跟踪。15. 服务管理：管理您的餐厅提供的额外服务，如餐饮或活动承办。跟踪服务预订并确保运营顺畅。16. 其他费用：设置和管理额外费用，如服务费、配送费或特殊活动费用。确保所有适用费用准确反映在客户账单中。17. 特价：管理和应用促销、折扣或忠诚度计划的特价。提供有竞争力的价格以吸引和留住客户。18. 订阅者管理：管理您的客户订阅列表以用于新闻通讯和促销。19. 电子营销：规划和执行电子邮件和短信营销活动。使用客户数据定位特定受众并推动更多业务到您的餐厅。此模块为您提供高效管理业务运营所需的所有工具，从员工和客户到菜单和营销，一切尽在掌握。',
      imenuBookInfo: 'iMenuBooks 模块是您全面的簿记和财务管理中心。此区域可让您无缝管理交易、连接银行账户并维护清晰准确的财务活动记录。以下是 iMenuBooks 模块的功能：1. 交易数据：管理和存储与您的业务相关的所有交易数据。此功能可让您跟踪每笔财务交易，确保您的记录准确且最新。2. 银行账户连接：将您的业务银行账户直接连接到 iMenuBooks 系统。此功能实现财务数据的自动同步，使管理收入、支出和账户余额更加容易。3. 查看交易：查看通过您的业务处理的所有财务交易的详细记录。此功能提供组织良好且可搜索的交易历史视图，让您轻松监控和审计财务活动。',
      reportsInfo: '报告模块是访问和分析业务绩效和财务数据的中心枢纽。此模块为您提供各种工具和报告，帮助您基于实时数据做出明智决策。以下是报告模块的功能：1. 付款：跟踪和审查客户的所有付款。此功能提供付款交易的详细分类，帮助您监控收入并确保准确的财务记录。2. 内部账户：管理和审查常客户使用的内部账户。此功能可让您跟踪账户余额、费用和付款，确保您的内部账户始终最新。3. 按客户收入：按单个客户分段分析收入数据。此报告帮助您识别关键客户并了解他们的购买行为，以便进行定向营销和改进客户关系。4. 按产品收入：查看基于特定产品的收入数据。此报告使您能够识别最畅销商品并了解产品表现，协助库存管理和产品开发决策。5. 动态报告：生成根据您的特定业务需求定制的报告。此功能可让您通过选择各种参数创建动态报告，让您从多个角度灵活分析数据。',
      configInfo: '商家设置模块允许您配置业务运营的各个方面，确保平台符合您的独特需求和偏好。此模块包括以下关键领域：1. 常规设置：• 业务信息：设置和更新您的业务的在线存在，包括名称、地址、联系详情、社交媒体链接和餐厅货币。• 在线存在：管理您的网站 URL、位置和传真详情。这对确保客户能够轻松找到并联系您至关重要。• 营业时间：设置和更新您的营业时间，确保客户知道您的营业时间。• 条款和政策：轻松编辑和管理您的使用条款、隐私政策和其他相关政策，以确保合规并与客户保持透明。• 餐饮和配送设置：定义餐饮状态、适用的邮政编码和餐饮活动类型。此外，管理配送区域并切换功能，如配送费用、地理位置查看和评分可见性。• 电子商务和在线销售：控制功能，如延迟费用发票、资产取货请求和押金，确保无缝的在线交易和订单管理。2. 功能：为餐饮订单和预订配置特定功能，包括餐桌位置偏好、客户预订视图、预付款选项和基于时间的设置。• 发票和报价设置：配置发票和报价的起始编号和前缀，帮助您维护有组织和专业的账单系统。• 订单管理：设置和管理订单前缀、取货时间和其他与订单相关的配置以简化订单处理。• 小费配置：管理小费要求，包括设置默认小费百分比，这在服务行业特别有用。• 可见性设置：控制某些信息或功能是否对客户可见，例如是否显示厨师或其他业务。3. 设计设置：• 配色方案：自定义您的应用程序的配色方案，包括主色、次色和第三色，以符合您的品牌标识。通过调整主色、次色和第三色、自定义数字标牌和管理关于我们的幻灯片来定制平台的视觉方面，以吸引人的方式展示您的业务。• 关于我们幻灯片：管理出现在您的“关于我们”部分中的幻灯片，让您展示您的业务的独特产品和服务。• 数字标牌：设置数字标牌以在您的应用程序或实体位置显示关键信息、菜单和广告。4. 备份和设备管理：• 设备管理：添加和管理连接到您的系统的设备，如 POS 系统、打印机等，确保一切同步并正常运行。• 备份选项：创建数据和设置的备份，以确保在出现任何技术问题时您有备用方案。您可以下载备份、从门户恢复或从文件恢复。通过备份、从文件恢复和管理连接的设备（如支付终端）确保数据安全。这些设置允许您根据业务需求定制 iMenuApps® 体验，使管理运营和维护一致的品牌形象在所有客户接触点上更加容易。',
      selections: '菜单',
      productManagement: '产品管理'
    },
    controlPanel: {
      googleCalendar: '谷歌日历',
      notificationCenter: '通知中心',
      notificationBell: '通知铃',
      salesByCustomers: '按客户销售',
      salesByProducts: '按产品销售',
      dynamicReport: '动态报告',
      events: "创建活动",
      eventTitle: "活动",
      transactionData: '添加和编辑财务交易',
      bankConnect: '添加银行账户和信用卡账户',
      viewTransaction: '添加/编辑/查看您的交易',
      subscription: '查看和创建订阅和账单（虚拟终端）',
      staff: '为业务员工创建用户账户',
      occupations: '管理业务职位。职位与员工相关。每位员工都有特定的职位。',
      roles: '角色管理。角色确定应用程序不同区域的权限，并与员工相关。一位员工可以拥有多个角色。',
      workSheet: '工作表。工作表可控制员工的工作时间。',
      customers: '显示业务客户列表',
      categories: '管理菜单的不同类别。类别与项目相关。一个项目属于一个类别。',
      menuItems: '管理项目/产品/服务。菜单由类别组成，而项目/产品/服务通过所属类别与菜单相关联。',
      services: '管理服务。服务用于餐饮菜单。',
      menus: '菜单管理。允许菜单管理。菜单由多个类别组成。',
      orders: '查看和创建订单。您可以在此处查看和创建订单',
      invoices: '查看和创建发票。您可以在此处查看和创建发票',
      quotes: '查看和创建报价。您可以在此处查看和创建报价',
      cateringOrders: '允许显示餐饮订单',
      orderForDelivery: '显示已准备好交付给已分配订单的司机的订单列表',
      tickets: '允许创建和跟踪票据。票据是在客户继续消费时保持开放的订单',
      otherCharges: '允许管理产品数量的额外费用',
      taxes: '税务管理。查看和创建销售税率',
      deliveries: '配送价格管理。查看和创建向客户收取的配送价格',
      reservations: '管理和创建预订和候补名单',
      tables: '业务容量管理。根据业务容量查看和创建预订',
      payments: '显示已进行的付款交易列表',
      aboutSettings: '允许管理每个业务主页上显示的幻灯片',
      paymentSettings: '允许配置将用于处理交易的支付网关',
      basicSettings: '允许配置业务的主要数据：名称、地址、电话...此信息显示在每个业务的主页上',
      funtionalitiesSettings: '允许配置业务的一般操作：营业时间、邮政编码、小费...',
      colorSettings: '允许配置应用程序的颜色',
      systemSettings: '允许配置 iMenuApps® 与第三方应用程序的集成',
      driver: '外部司机管理',
      credit: '允许信用管理'
    },
    options: {
      sameAsBilling: '同账单地址',
      contactPerson: '联系人',
      email: '邮箱',
      aditionalDetails: '其他详情',
      street: '街道',
      text: '设置默认地址时出现问题',
      updateAddress: '地址已更新',
      wrongAddress: '尝试更新默认地址时出错',
      billingAddress: '账单地址',
      shippingAddress: '配送地址',
      placeholderNotes: '在此输入备注',
      dataRequired: '必填数据',
      customerArea: '客户区域',
      customerName: '客户姓名',
      customerEmail: '客户邮箱',
      customerPhone: '客户电话',
      customerAddress: '客户地址',
      terms: '条款',
      trackingN: '跟踪编号',
      shippingDate: '配送日期',
      shippingTo: '配送至',
      footer: '编辑您的收入模块的相应页脚',
      ivoiceDate: '发票日期',
      quoteDate: '报价日期',
      subscriptionBilling: '订阅账单',
      driverDeliveries: '配送',
      activeDriverOrder: '活跃订单',
      completedDriverOrder: '已完成订单',
      useDirection: '点击如果与账单地址相同',
      menuTitle: '管理',
      login: '登录',
      logout: '退出',
      controlPanel: '控制面板',
      adminSettings: '管理员设置',
      supportPanel: '支持',
      manageMenus: '菜单',
      managePyments: '付款',
      manageHouseAccount: '内部账户',
      viewOrders: '查看/创建订单',
      viewQuotes: '报价',
      viewInvoice: '发票',
      manageCategories: '类别',
      manageProducts: '项目',
      manageServices: '服务',
      manageCustomers: '客户',
      manageCredits: '信用',
      manageTables: '餐桌',
      manageTaxes: '税务',
      manageShippings: '配送价格',
      manageOtherCharges: '其他费用',
      manageUsers: '员工',
      manageDriver: '司机',
      manageRoles: '角色/权限',
      manageWorkSheet: '工作表',
      manageBasicSettings: '业务',
      manageRestaurantSettings: '业务设置',
      manageAboutSettings: '关于我们幻灯片',
      manageFunSettings: '功能',
      manageColourSettings: '颜色',
      manageDesign: '设计',
      manageMore: '更多',
      managePaymentSettings: '付款',
      manageOccupation: '职位',
      manageKeySettings: '外部系统',
      supportSettings: '支持设置',
      changeServerId: '更改员工编号',
      serverId: '员工编号',
      manageVariantGroup: '选项',
      manageReservation: '预订',
      manageWaitList: '候补名单',
      viewCateringOrders: '餐饮订单',
      forgotPassword: '忘记密码？',
      sendNewPassword: '发送新密码',
      serverIdMessage: '这是您的个人资料创建时分配给您的安全代码',
      recoveryPassword: '恢复密码',
      refund: '退款',
      void: '作废'
    },
    titles: {
      technology: "科技",
      retail: "零售",
      healthcare: "医疗",
      finance: "金融",
      retailGeneralMerchandise: "零售（综合商品）",
      healthcareServices: "医疗服务",
      foodAndBeverage: "餐饮（餐厅、咖啡馆、酒吧）",
      construction: "建筑",
      eCommerce: "电子商务",
      informationTechnology: "信息技术（IT 服务和软件开发）",
      realEstate: "房地产（住宅和商业）",
      transportationLogistics: "运输和物流",
      professionalServices: "专业服务（咨询、法律、会计）",
      manufacturing: "制造业（通用和专用）",
      educationTraining: "教育和培训服务",
      entertainmentMedia: "娱乐和媒体",
      financialServices: "金融服务（银行、投资公司）",
      personalCareServices: "个人护理服务（沙龙、水疗）",
      hospitality: "酒店业（酒店、旅行社）",
      insuranceAgencies: "保险机构",
      homeImprovementRepair: "家居装修和维修",
      automotiveServices: "汽车服务（维修、经销商、车身修理）",
      telecommunications: "电信",
      nonprofitSocialServices: "非营利和社会服务",
      agricultureFarming: "农业和农场",
      pharmaceuticalsBiotechnology: "制药和生物技术",
      energy: "能源（可再生和不可再生）",
      sportsRecreation: "体育和娱乐",
      fitnessWellness: "健身和健康",
      marketingAdvertising: "营销和广告",
      eventPlanning: "活动策划和服务",
      cleaningServices: "清洁服务（住宅和商业）",
      fashionApparel: "时尚和服装",
      foodProductionProcessing: "食品生产和加工",
      petServices: "宠物服务（美容、寄宿、兽医）",
      artsCrafts: "艺术和手工艺（创意服务）",
      aerospaceDefense: "航空航天和国防",
      environmentalServices: "环境服务",
      technologyHardwareElectronics: "技术硬件和电子",
      childcareServices: "儿童保育服务",
      securityServices: "安全服务（网络安全、物理安全）",
      publishing: "出版（书籍、杂志、数字媒体）",
      transportationEquipmentManufacturing: "运输设备制造",
      architectureDesign: "建筑和设计",
      accountingTaxPreparation: "会计和税务准备",
      landscapingGardening: "景观设计和园艺",
      beverageProduction: "饮料生产（精酿啤酒、葡萄酒、烈酒）",
      medicalDevicesSupplies: "医疗设备和用品",
      warehousingStorage: "仓储和存储",
      freelancing: "自由职业（写作、平面设计、编程）",
      tourismAdventureServices: "旅游和探险服务",
      utilitiesPublicServices: "公用事业和公共服务",
      blockchainCryptocurrency: "区块链和加密货币",
      specializedRetail: "专业零售（利基产品和服务）",
      eventPlanningServices: "活动策划和服务",
      transportationEquipment: "运输设备制造",
      accountingTax: "会计和税务准备",
      tourismAdventure: "旅游和探险服务",
      shareViaEmailAndSMS: '通过邮件和短信分享',
      sendEmail: '发送邮件',
      sendSMS: '发送短信',
      send: "发送",
      sendNow: '立即发送',
      schedule: '定时发送',
      cancel: '取消',
      searchCustomer: '搜索客户或订阅者',
      emailPlaceholder: '邮箱',
      phonePlaceholder: '电话号码',
      sendByEmailAndSMS: '通过邮件和短信发送',
      textSend: '您可以通过在每个邮箱后添加逗号来添加多个邮箱地址',
      sendNotification: '您即将向以下对象发送此通知：',
      whenToSend: '您希望何时发送？',
      bankAccountName: '银行账户名称',
      routeNumber: '路由号码',
      accountNumber: '账户号码',
      bankAccountAddress: '银行账户地址',
      nameAuthorizedPerson: '授权人姓名',
      paymentAmount: '付款金额',
      mustBe: '必须为 9 位数字',
      warning: '警告',
      messageChangeQuote: '如果您再次更改此前缀，您的报价编号顺序将更改',
      messageChangeIvoice: '如果您再次更改此前缀，您的发票编号顺序将更改',
      messageStartingInvoiceNumber: '如果您更改此起始编号，您的发票编号将重置从此编号开始',
      prefixQuotes: '报价前缀（例如 QTE）',
      prefixInvoices: '发票前缀（例如 INV）',
      invoiceStartingNumber: '发票起始编号',
      moneyNotEnought: '金额必须大于总额才能获得找零',
      controlPanel: '控制面板',
      supportPanel: '支持',
      menus: '菜单',
      orders: '订单',
      quotes: '报价',
      invoices: '发票',
      allOrders: '所有订单',
      customerCredit: '客户信用',
      workSheet: '工作表',
      cateringOrders: '餐饮订单',
      ordersForDelivery: '待配送订单',
      suscriptors: '订阅者',
      tickets: '订单票据',
      categories: '类别',
      products: '项目',
      customers: '客户',
      tables: '餐桌',
      taxes: '税务',
      shippings: '配送价格',
      otherCharges: '其他费用',
      newsletter: '新闻通讯',
      users: '员工',
      suscriptor: '订阅者',
      createCustomer:"创建客户",
      communicationResponse: '沟通回复',
      smsResposes: "短信回复",
      emailResponses: "邮件回复",
      loadingEmailResponses: "正在加载邮件回复...",
      loadingSmsResponses: "正在加载短信回复...",
      perPage: "每页",
      emailNoSent: "未发送邮件",
      noEmailResponses: "无邮件回复",
      noEmailFound: "未找到您账户的邮件回复",
      noSmsResponses: "无短信回复",
      noSmsFound: "未找到您账户的短信回复",
      createSubscriptor: "创建订阅者",
      occupation: '职位',
      roles: '角色',
      about: '关于我们幻灯片',
      digitalScreens: '数字屏幕',
      editAboutForm: '编辑关于我们幻灯片',
      newAboutForm: '创建新的关于我们幻灯片',
      editDisplayForm: '编辑数字标牌幻灯片',
      newDisplayForm: '创建数字标牌幻灯片',
      basicConfig: '基本配置',
      functions: '功能',
      colors: '颜色',
      variantGroup: '选项',
      loading: '请稍候...',
      editColorSetting: '编辑颜色',
      createColorSetting: '创建颜色',
      orderCateringForm: '编辑餐饮订单',
      deliveryLocation: '配送地点',
      cateringMenus: '餐饮菜单',
      payments: '付款',
      ticketDetails: '票据详情',
      emptyResult: '无结果',
      cancellationType: '取消类型',
      changePassword: '更改密码',
      restaurantName: '业务名称',
      clockinClockout: '打卡 - 下班',
      clockin: '打卡',
      clockout: '下班',
      timecard: '考勤卡',
      timesheet: '时间表',
      addContact: '添加联系人',
      updateContact: '更新联系人',
      contacts: '联系人',
      staff: '员工'
    },
          placeholder: {
        contactNotFound: '未找到联系人'
      },
      orderState: {
        started: '已开始',
        inKitchen: '厨房处理中',
        cooked: '已烹饪',
        delivering: '待配送',
        delivered: '已送达'
      },
      list: {
        buttons: {
          goToControlPanel: '前往管理面板'
        },
        actions: {
          addANew: '新增',
          edit: '编辑',
          delete: '删除',
          view: '查看'
        },
        entitiesName: {
          menu: '菜单',
          category: '分类',
          categoryPlaceholder: '选择分类',
          product: '商品',
          customer: '客户',
          table: '餐桌',
          tax: '税费',
          taxPlaceholder: '选择税费',
          shipping: '配送',
          otherCharge: '其他费用',
          user: '用户',
          order: '订单',
          role: '角色',
          about: '关于'
        },
        messages: {
          confirmDelete: '确认删除',
          confirmAccept: '确认商品',
          confirmProduct: '您要接受此商品吗？',
          deleteCategory: '您要删除此分类吗？',
          deleteRestaurant: '您要删除此商家吗？',
          deleteOrder: '您要删除此订单吗？',
          deleteCredit: '您要删除此信用吗？',
          deleteWorkSheet: '您要删除此工作表吗？',
          deleteCustomer: '您要删除此客户吗？',
          deleteMenu: '您要删除此菜单吗？',
          deleteOtherCharge: '您要删除此其他费用吗？',
          deleteNewsletter: '您要删除此通讯吗？',
          deleteProduct: '您要删除此商品吗？',
          deleteShipping: '您要删除此配送吗？',
          deleteTable: '您要删除此餐桌吗？',
          deleteTax: '您要删除此税费吗？',
          deleteUser: '您要删除此用户吗？',
          deleteSuscriptor: '您要删除此订阅者吗？',
          deleteRole: '您要删除此角色吗？',
          deleteAbout: '您要删除此信息吗？',
          deleteDisplay: '您要移除此广告吗？',
          deleteOccupation: '您要删除此职业吗？',
          deleteVariantGroup: '您要删除此选项吗？',
          infoDeleteSuccess: '信息',
          invalidCode: '无效代码，请重试。',
          messageDeleteSuccessCategory: '分类已成功删除',
          messageDeleteSuccessRestaurant: '商家已成功删除',
          messageDeleteSuccessOrder: '订单已成功删除',
          messageDeleteSuccessCredit: '信用已成功删除',
          messageDeleteSuccessWorkSheet: '工作表已成功删除',
          messageDeleteSuccessCustomer: '客户已成功删除',
          messageDeleteSuccessMenu: '菜单已成功删除',
          messageDeleteSuccessOtherCharges: '其他费用已成功删除',
          messageDeleteSuccessNewsletter: '通讯已成功删除',
          messageDeleteSuccessProduct: '商品已成功删除',
          messageDeleteSuccessShipping: '配送已成功删除',
          messageDeleteSuccessTable: '餐桌已成功删除',
          messageDeleteSuccessTax: '税费已成功删除',
          messageDeleteSuccessUser: '用户已成功删除',
          messageDeleteSuccessSuscriptor: '订阅者已成功删除',

          messageActivareSuccessSuscriptor: '订阅者已成功激活',
          messageDesactivareSuccessSuscriptor: '订阅者已成功停用',

          messageDeleteSuccessRole: '角色已成功删除',
          messageDeleteSuccessAbout: '信息已成功删除',
          messageDeleteSuccessOccupation: '职业已成功删除',
          messageDeleteSuccessVariantGroup: '选项已成功删除',
          messageCateringApproved: '餐饮订单已成功批准',
          messageCateringCancelled: '餐饮订单已成功取消',
          titleEditCategory: '编辑分类',
          titleEditCustomer: '编辑客户',
          titleEditMenu: '编辑菜单',
          titleEditOtherCharges: '编辑其他费用',
          titleEditProduct: '编辑商品',
          titleEditShipping: '编辑配送',
          titleEditTable: '编辑餐桌',
          titleEditTax: '编辑税费',
          titleEditUser: '编辑用户',
          titleEditRole: '编辑角色',
          titleEditSetting: '编辑设置',
          titleEditOccupation: '编辑职业',
          titleCreateCategory: '创建分类',
          titleCreateCustomer: '创建客户',
          titleCreateMenu: '创建菜单',
          titleCreateOtherCharges: '创建其他费用',
          titleCreateProduct: '创建商品',
          titleCreateShipping: '创建配送',
          titleCreateTable: '创建餐桌',
          titleCreateTax: '创建税费',
          titleCreateUser: '创建用户',
          titleCreateRole: '创建角色',
          titleCreateSetting: '创建设置',
          titleCreateOccupation: '创建职业',
          titleEditVariantGroup: '编辑选项',
          titleCreateVariantGroup: '创建新选项',
          messageEditSuccessCategory: '分类已成功编辑',
          messageEditSuccessCredit: '信用已成功编辑',
          messageEditSuccessCustomer: '客户已成功编辑',
          messageEditSuccessMenu: '菜单已成功编辑',
          messageEditSuccessWorksheet: '工作表已成功编辑',
          messageEditSuccessOtherCharges: '其他费用已成功编辑',
          messageEditSuccessProduct: '商品已成功编辑',
          messageEditSuccessShipping: '配送已成功编辑',
          messageEditSuccessTable: '餐桌已成功编辑',
          messageEditSuccessTax: '税费已成功编辑',
          messageEditSuccessUser: '用户已成功编辑',

          messageEditSuccessSuscriptor: '订阅者已成功编辑',
          messageEditSuccesRole: '角色已成功编辑',
          messageEditSuccessSetting: '设置已成功编辑',
          messageEditSuccessOccupation: '职业已成功编辑',
          messageEditSuccessVariantGroup: '选项已成功编辑',
          messageDeleteSuccessVariant: '选项已成功删除',
          messageEditSuccessVariant: '选项已成功编辑',
          messageCreateSuccessVariant: '选项已成功创建',
          messageCreateSuccessCategory: '分类已成功创建',
          messageCreateSuccessCredit: '信用已成功创建',
          messageCreateSuccessCustomer: '客户已成功创建',
          messageCreateSuccessMenu: '菜单已成功创建',
          messageCreateSuccessWorksheet: '工作表已成功创建',
          messageCreateSuccessOtherCharges: '其他费用已成功创建',
          messageCreateSuccessProduct: '商品已成功创建',
          messageCreateSuccessShipping: '配送已成功创建',
          messageCreateSuccessTable: '餐桌已成功创建',
          messageCreateSuccessTax: '税费已成功创建',
          messageCreateSuccessUser: '用户已成功创建',
          messageCreateSuccessSuscriptor: '订阅者已成功创建',
          messageCreateSuccessRole: '角色已成功创建',
          messageCreateSuccessSetting: '设置已成功创建',
          messageCreateSuccessOccupation: '职业已成功创建',
          messageCreateSuccessVariantGroup: '选项已成功创建',
          menuChangeState: '菜单状态已成功更改',
          activeMenu: '激活菜单',
          otherChargeChangeState: '其他费用状态已成功更改',
          activeOtherCharge: '激活其他费用',
          taxChangeState: '税费状态已成功更改',
          activeTax: '激活税费',
          shippingChangeState: '配送状态已成功更改',
          activeShipping: '激活配送',
          deleteSubtitleCategory: '删除分类',
          deleteSubtitleCustomer: '删除客户',
          deleteSubtitleMenu: '删除菜单',
          deleteSubtitleOtherCharges: '删除其他费用',
          deleteSubtitleProduct: '删除商品',
          deleteSubtitleShipping: '删除配送',
          deleteSubtitleTable: '删除餐桌',
          deleteSubtitleTax: '删除税费',
          deleteSubtitleUser: '删除用户',
          deleteSubtitleRole: '删除角色',
          deleteSubtitleAbout: '删除信息',
          deleteSubtitleOccupation: '删除职业',
          deleteSubtitleVariantGroup: '删除选项',
          deleteAertMessage: '您确定要删除此联系人吗？',
          errorTitle: '错误',
          errorMessage: '出了点问题。',
          changeOrderStateMessage: '更改订单状态',
          changeOrderStateSuccess: '订单状态已成功更改',
          changeOrderStateCanceled: '订单已取消',
          connectionError: '连接错误',
          sharedWorksheet: '与员工共享工作表',
          connectionErrorMessage: '连接错误。请检查您的互联网连接并重试。如果问题仍然存在，请联系您的服务提供商。',
          newPasswordSent: '新密码已发送至您的邮箱',
          emailOrPasswordIncorrect: '邮箱或密码错误',
          buttons: {
            cancel: '取消',
            delete: '删除',
            close: '关闭',
            goToAdministration: '前往管理',
            goToList: '前往列表',
            retry: '重试'
          }
        }
      },
      form: {
        includeMiddleName: '包括中间名和姓',
        login: '登录',
        events: {
          backgroundImage: '背景图片',
          backgroundColor: '背景颜色',
          backgroundColorSection: '为此部分添加背景颜色',
          backgroundColorDates: '日期的背景颜色',
          backgroundColorTitle: '标题的背景颜色',
          backgroundColorSubtitle: '副标题的背景颜色',
          backgroundColorDescription: '描述的背景颜色',
          backgroundColorFooter: '页脚的背景颜色',
          startDate: '开始日期',
          endDate: '结束日期',
          startTime: '开始时间',
          endTime: '结束时间',
          dates: '日期',
          title: '标题',
          subtitle: '副标题',
          description: '描述',
          footer: '页脚',
          saveToCalendar: '添加到谷歌日历'
        },
        colour: {
          primaryColor: '主色',
          primary: '主要',
          primaryText: '主要文本',
          secondaryColor: '次要颜色',
          secondary: '次要',
          secondaryText: '次要文本',
          tertiaryColor: '第三颜色',
          tertiary: '第三',
          tertiaryText: '第三文本',
          successColor: '成功颜色',
          success: '成功',
          successText: '成功文本',
          dangerColor: '危险颜色',
          danger: '危险',
          dangerText: '危险文本',
          backgroundColor: '背景颜色',
          background: '背景'
        },
        tableShape: {
          square: '正方形',
          rectangular: '长方形',
          circle: '圆形',
          oval: '椭圆形'
        },
        buttons: {
          backToCategoriesList: '返回分类列表',
          backToCustomersList: '返回客户列表',
          backToMenusList: '返回菜单列表',
          backToOrdersList: '返回订单列表',
          backToOtherChargesList: '返回其他费用列表',
          backToProductsList: '返回商品列表',
          backToShippingsList: '返回配送列表',
          backToTablesList: '返回餐桌列表',
          backToTaxesList: '返回税费列表',
          backToUsersList: '返回用户列表',
          backToRolesList: '返回角色列表',
          backToAboutList: '返回关于列表',
          backToMenu: '返回菜单',
          cancelOrder: '取消订单',
          changeState: '更改状态为',
          defaultColor: '默认',
          addChoice: '添加选项',
          back: '返回',
          save: '保存',
          submit: '提交',
          change: '更改',
          add: '添加',
          update: '更新'
        },
        titles: {
          identificationInformation: '身份信息',
          idType: '证件类型',
          driverLicense: '驾驶证',
          internationalId: '国际身份证（身份证）',
          nameLicense: '驾驶证上的姓名',
          licenseNumber: '驾驶证号码',
          issueDate: '签发日期',
          expirationDate: '到期日期',
          sex: '性别',
          dateBirth: '出生日期',
          meters: "米",
          feet: "英尺",
          centimeters: "厘米",
          inches: "英寸",
          height: '身高',
          nameId: '证件上的姓名',
          identificationNumber: '证件号码',
          nationality: '国籍',
          martialStatus: '婚姻状况',
          single: '单身',
          married: '已婚',
          divorced: '离异',
          widowed: '丧偶',
          occupation: '职业',
          socialeMediaChannels: '社交媒体渠道',
          customerType: '客户类型',
          customerStatus: '客户状态',
          gender: '性别',
          preferredContact: '首选联系方式',
          enableAll: '全部启用',
          disableAll: '全部禁用',
          invoiceReminderLabel: '输入每隔多少天发送提醒',
          invoiceReminder: '开启发票提醒',
          assetPickupRequest: '资产取件请求',
          pickupAddress: '取件地址',
          requireDeposit: '需要押金',
          lateFees: '开启滞纳金发票',
          lateFeesLabel: '输入要收取的欠款百分比',
          thisInvoice: '此发票已支付',
          customerNewTitle: '创建新客户',
          customerEditTitle: '编辑客户',
          categoryNewTitle: '创建新分类',
          creditNewTitle: '创建新信用',
          categoryEditTitle: '编辑分类',
          creditEditTitle: '编辑信用',
          menuNewTitle: '创建新菜单',
          workSheetNewTitle: '创建工作表',
          menuEditTitle: '编辑菜单',
          workSheetEditTitle: '编辑工作表',
          productNewTitle: '创建商品',
          serviceNewTitle: '创建服务',
          productEditTitle: '编辑商品',
          serviceEditTitle: '编辑服务',
          changePaymentSetting: '更改支付设置',
          shippingNewTitle: '创建新配送价格',
          shippingEditTitle: '编辑配送价格',
          taxNewTitle: '创建新税费',
          taxEditTitle: '编辑税费',
          tableNewTitle: '创建新餐桌',
          tableEditTitle: '编辑餐桌',
          packageNewTitle: '创建新套餐',
          packageEditTitleditTitle: '编辑套餐',
          variantGroupEditTitle: '编辑选项',
          variantGroupNewTitle: '创建新选项',
          otherChargeNewTitle: '创建新其他费用',
          otherChargeEditTitle: '编辑其他费用',
          userNewTitle: '创建新员工',

          suscriptionNewTitle: '创建新订阅',

          driversNewTitle: '创建新司机',
          userEditTitle: '编辑员工',

          suscriptionEditTitle: '编辑订阅',
          driversEditTitle: '编辑司机',
          supportUsers: '支持用户',
          occupationNewTitle: '创建新职业/工作',
          occupationEditTitle: '编辑职业/工作',
          roleNewTitle: '添加权限',
          roleEditTitle: '编辑角色',
          selectAProduct: '选择商品',
          selectACategory: '选择分类',
          selectACustomer: '选择客户',
          selectATax: '选择税费',
          selectARestaurant: '选择商家',
          selectAState: '选择状态',
          filterCategory: '筛选...',
          selectALanguage: '语言',
          selectAnOccupation: '选择职业',
          selectACooker: '选择厨师',
          selectADriver: '选择司机',
          allProducts: '所有商品:',
          settingEditTitle: '编辑设置',
          settingNewTitle: '添加设置',
          generalSettingEditTitle: '编辑基本设置',
          generalSettingNewTitle: '添加基本设置',
          keySettingEditTitle: '编辑系统设置',
          keySettingNewTitle: '创建系统设置',
          funSettingEditTitle: '功能设置',
          funSettingNewTitle: '创建功能设置',
          pickFromSelect: '选择取件起始',
          pickToSelect: '选择取件结束',
          dateFromSelect: '选择起始日期',
          dateToSelect: '选择结束日期',
          cancelOrder: '取消订单',
          drivers: '司机',
          customer: '客户',
          date: '日期',
          startDate: '开始日期',
          endDate: '结束日期',
          orderType: '订单类型',
          addressToDelivery: '配送地址',
          hourToPick: '取件时间',
          tableService: '餐桌服务',
          products: '商品',
          services: '服务',
          otherCharges: '其他费用',
          shippingPrice: '配送价格',
          subtotal: '小计',
          tax: '税费总计',
          tip: '小费',
          total: '总计',
          number: '编号',
          doYou: '您真的要删除',
          marked: '标记的记录吗？',
          pendingPay: '待支付',
          payed: '已支付',
          notes: '备注',
          cancelNotes: '取消备注',
          pickupNotes: '取件备注',
          cooker: '厨师',
          state: '状态',
          generalConfiguration: '常规配置',
          paymentConfiguration: '支付配置',
          cashDiscount: '现金折扣',
          eposConfiguration: 'EPOS配置',
          emailConfiguration: '邮箱配置',
          twilioSMS: 'Twilio短信',
          sinchSMS: 'Sinch短信',
          selectAVariantGroup: '选择选项',
          imageText: '为了最佳效果，请上传750x750像素的图片。确保您拥有上传图片的版权。',
          orderCateringForm: '餐饮订单批准',
          restaurantHours: '营业时间',
          deadlinesNotes: '请确保截止日期的总和为100。',
          selectDate: '选择日期',
          toPay: '待支付',
          pending: '待处理',
          genaral: '常规',
          others: '其他',
          variants: '变体',
          sides: '配菜',
          ingredients: '配料',
          shift4: 'Shift4',
          auth: 'Authorize.Net',
          capcha: '验证码',
          zipCodes: '邮编',
          backups: '备份',
          devices: '设备',
          creditSetting: '信用设置'
        },
        fields: {
          createNewCustomer: '创建新客户',
          editItem: '编辑商品',
          previewInvoice: '预览发票',
          companyName: '公司名称',
          companyEmail: '公司邮箱',
          companyPhone: '公司电话',
          companyTitle: '职位',
          companyWebSite: '公司网站',
          companyIndustry: '公司行业',
          addNewCustomer: '添加新客户',
          projectName: '项目名称',
          billingAddress: '账单地址',
          selectCustomerAttachBillingAddress: '选择客户以附加账单地址',
          selectCustomerAttachShippingAddress: '选择客户以附加配送地址',
          selectedAddress: '所选地址:',
          changeAddress: '更改',  
          addAddress: '添加',
          number: '编号',
          shippingAddress: '配送地址',
          username: '用户名',
          emailLabel: '邮箱',
          phoneLabel: '电话',
          firstNameLabel: '名字',
          lastNameLabel: '姓氏',
          putEmail: '输入您的邮箱',
          putPhone: '输入您的电话',
          putFirstName: '输入您的名字',
          putLastName: '输入您的姓氏',
          putUserName: '输入您的用户名',
          takePicture: '拍照',
          accept: '接受',
          hidde: '隐藏',
          delete: '删除',
          retake: '重拍',
          previewPhoto: '预览照片',
          previewAcceptedPhoto: '预览已接受照片',
          viewImenuBookControlPanel: '在控制面板查看iMenuBooks',
          viewImenuEngageControlPanel: '在控制面板查看iMenuEngage360',
          viewImenuBookOptions: '查看iMenuBooks选项',
          viewOrdersOption: '查看订单选项',
          viewReservationOption: '查看预订选项',
          viewInvoiceOption: '查看发票选项',
          viewQuoteOption: '查看报价选项',
          changeImage: '更改图片',
          addImage: '添加图片',
          customerHours: '客户时间',
          to: '至',
          subject: '主题',
          message: '消息',
          name: '名称',
          menuName: '菜单名称',
          description: '描述',
          email: '邮箱',
          password: '密码',
          date: '日期',
          image: '图片',
          phone: '电话',
          productMin: '商品最小',
          productMax: '商品最大',
          price: '价格',
          extraCharge: '额外费用',
          costPrice: '成本',
          retailPrice: '售价',
          stimateTime: '预计时间（分钟）',
          stockQuantity: '库存数量',
          minReorderPoint: '最低库存数量',
          maxReorderPoint: '最高库存数量',
          CreditAmount: '信用金额',
          vendorName: '供应商名称',
          vendorCode: '供应商代码',
          shortDescription: '简短描述',
          keywords: '关键词',
          tags: '标签',
          binNumber: '箱号',
          addSerialNumber: '添加序列号',
          active: '激活',
          save: '保存',
          submitToken: '提交令牌',
          available: '可用',
          availableCategories: '可用分类',
          availableProducts: '可用商品',
          availableStaff: '可用员工',
          selectedProducts: '已选商品',
          selectedCategories: '已选分类',
          selectedStaff: '已选员工',
          workedHours: '工作时间',
          scheduledDates: '预定日期',
          selectedAggregates: '已选聚合',
          marketingConsent: '营销同意',
          product: '商品',
          category: '分类',
          tax: '税费',
          parentCategory: '父分类',
          qrCode: '二维码',
          capacity: '容量',
          percent: '百分比',
          priority: '优先级（0 - 1）',
          permissions: '权限',
          permissionsRole: '权限角色',
          selectCashDiscount: '选择现金折扣',
          roles: '职业/工作',
          address: '地址',
          title: '标题',
          subtitle: '副标题',
          online: '在线',
          showOtherRestaurant: '显示其他商家',
          reservationByTable: '预订餐桌',
          reservationByStaff: '预订员工',
          tablesChoose: '客户可以选择餐桌位置',
          onlineMss: '商家对公众不可见',
          onlineMss1: '商家对公众可见',
          mustClockinMss: '您必须先打卡。请',
          mustClockin2Mss: '打卡。',
          SelectPickHour: '选择取件时间',
          SelectPickHour2: '激活取件时间',
          TipRequire: '需要小费',
          tips: '小费',
          assetPickup: '资产取件',
          depositAmount: '押金金额',
          typeTip: '输入小费百分比',
          MinTimeToCook: '最短烹饪时间',
          PickFrom: '取件开始于',
          PickFromToolTip: '添加配送开始时间',
          PickTo: '取件结束时间',
          PickToToolTip: '添加配送结束时间',
          DateFrom: '起始日期',
          DateTo: '结束日期',
          DateLimit: '支付截止日期',
          ShowCooker: '显示厨师',
          zipCodes: '邮编',
          deliveryZone: '配送区域',
          cooker: '厨师',
          driver: '司机',
          rejectedOrder: '订单被司机拒绝',
          cancelationNote: '取消备注',
          tableNumber: '餐桌编号',
          firstName: '名字',
          lastName: '姓氏',
          occupation: '职业',
          confirmPassword: '确认密码',
          endPointUrl: '端点URL',
          capchaKey: '验证码密钥',
          clientGuid: '客户端GUID',
          interfazVersion: '接口版本',
          interfazName: '接口名称',
          apiLoginId: 'API登录ID',
          eposToken: 'ePos令牌',
          epos: '与ePos集成',
          transactionKey: '交易密钥',
          smtpHost: 'SMTP主机',
          port: '端口',
          secure: '安全',
          twFromNumber: '来自号码',
          twAccountSID: '账户SID',
          twToken: '令牌',
          sinchFromNumber: '来自号码',
          sinchAccountSID: '服务计划ID',
          sinchToken: '令牌',
          web: '网站',
          variantGroup: '选项',
          haveSides: '配菜',
          cantOfSides: '包含的配菜数量',
          categoryOfSides: '筛选配菜分类',
          addIngredients: '指定配料',
          typeAnIngredient: '输入配料',
          canViewGeoposition: '可以查看地理位置',
          canViewRating: '可以查看评分',
          viewDelivery: '可以创建配送订单',
          viewOnTable: '可以创建餐桌订单',
          viewCurbside: '可以创建路边订单',
          tablePrefix: '餐桌前缀',
          barPrefix: '酒吧前缀',
          roomPrefix: '房间前缀',
          typeZipCode: '输入邮编',
          isCatering: '是餐饮',
          isService: '服务菜单',
          isReservationMenu: '预订菜单',
          catering: '餐饮',
          minAmoutCatering: '餐饮最低金额',
          minAmountCateringDelivery: '配送最低金额',
          loyaltyMinPointToBuy: '购买最低积分',
          loyaltyExpirationMonths: '忠诚度过期月数',
          loyaltyPointMoney: '1美元的积分数量',
          partialPay: '部分支付',
          payForQuotation: '报价预支付',
          percentPayForQuotation: '报价预支付金额',
          service: '服务',
          showServicePrice: '显示服务价格',
          viewCatering: '查看餐饮',
          viewLoyalty: '查看忠诚度计划',
          viewReservation: '查看预订',
          reservation: '预订',
          loyalty: '忠诚度计划',
          minDayToReservation: '预订的最少天数',
          viewCustomerReservation: '查看客户预订',
          sameHourForAllDays: '所有天相同时间',
          followingDays: '以下天相同时间',
          timezone: '时区',
          monday: '周一',
          tuesday: '周二',
          wednesday: '周三',
          thursday: '周四',
          friday: '周五',
          saturday: '周六',
          sunday: '周日',
          allDays: '所有天',
          marginDays: '下单的最少天数',
          cateringStates: '餐饮状态',
          typeState: '输入状态代码',
          zipCodesExclude: '包含的邮编',
          cateringEvents: '餐饮活动',
          typeEventName: '输入活动名称',
          proposeNewDataTime: '提议新的日期/时间',
          fixed: '固定金额',
          amount: '金额',
          discount: '折扣',
          deadlines: '截止日期',
          pendingPay: '待支付',
          payed: '已支付',
          states: '状态',
          paymentMethod: '支付方式',
          cash: '现金',
          card: '卡',
          check: '支票',
          free: '空闲',
          busy: '忙碌',
          dirty: '脏',
          authenticationToken: '授权令牌',
          authenticationTokenMoto: 'MOTO授权令牌',
          authenticationTokenFB: '餐饮授权令牌',
          accountType: '账户类型',
          method: '方法',
          serverName: '服务器名称',
          urlLocation: 'URL位置',
          fax: '传真',
          oldServerId: '旧员工ID',
          newServerId: '新员工ID',
          acivateTwilio: '激活Twilio',
          acivateSinch: '激活Sinch',
          isDriver: '是司机',
          monthy: '月度',
          anual: '年度',
          merchantOnboardingApplication: '商户入职申请',
          applicationName: '应用名称',
          agentId: '代理ID',
          planId: '计划ID',
          dateOfBirth: '出生日期',
          equityOwnershipPercent: '股权百分比',
          isPersonalGuarantor: '是个人担保人？',
          bookablePackage: '是可预订套餐',
          showProgressBar: '向司机显示进度条'
        },
        messages: {
          buttons: {
            ok: '确定',
            dismiss: '忽略'
          },
          activatePaymentMethod: '已激活。',
          incorrectToken: '发送的令牌不正确。',
          activationMethodError: '激活方法返回错误。',
          unexpectedError: '发生意外错误。',
          savePaymentMethodSuccess: '支付方法设置已保存。',
          savePaymentMethodError: '保存支付方法设置时出错。'
        },
        validate: {
          emailExisteTitle: '邮箱已存在',
          emailExistMessage: '此邮箱已注册。请使用其他邮箱地址或让用户在登录屏幕点击“忘记密码”。',
          validate: '验证',
          validateCategory: '验证分类',
          validateCustomer: '验证客户',
          validateMenu: '验证菜单',
          validateOtherCharge: '验证其他费用',
          validateProduct: '验证商品',
          validateShipping: '验证配送',
          validateTable: '验证餐桌',
          validateTax: '验证税费',
          validateUser: '验证用户',
          validateRole: '验证角色',
          validateSetting: '验证设置',
          validateOccupation: '验证职业',
          validateVariantGroup: '验证选项',
          name: '名称必填',
          image: '图片必填',
          email: '邮箱必填',
          phone: '电话必填',
          emailIncorrect: '邮箱不正确',
          date: '日期必填',
          selectedCategories: '必须选择分类',
          productMinNumber: '商品最小必须为数字',
          productMaxNumber: '商品最大必须为数字',
          productMinGreater: '商品最小必须大于0',
          productMaxGreater: '商品最大必须大于2',
          price: '价格必须为数字',
          priceGreater: '价格必须大于0',
          product: '必须选择商品',
          costPriceNumber: '成本价格必须为数字',
          retailPriceNumber: '售价必须为数字',
          retailPriceShouldBeGreaterThanSalePrice: '零售价格应始终大于售价',
          costPriceGreater: '成本价格必须大于0',
          retailPriceGreater: '售价必须大于0',
          category: '必须选择分类',
          capacity: '容量必须为数字',
          capacityGreater: '容量必须大于0',
          percent: '百分比必须为数字',
          percentGreater: '百分比必须大于0',
          password: '密码必填',
          address: '地址必填',
          title: '标题必填',
          subtitle: '副标题必填',
          zipCode: '邮编无效',
          duplicateZipCode: '重复邮编',
          cateringPriceZero: '餐饮价格为零',
          cooker: '必须填写厨师字段',
          tableNumber: '餐桌编号必须为数字',
          tableNumberGreater: '餐桌编号必须大于0',
          nameDuplicate: '已有此名称的餐桌。您必须更改编号或类型。',
          firstName: '必须填写名字字段',
          lastName: '必须填写姓氏字段',
          confirmPassword: '密码和确认密码必须相同',
          occupation: '必须填写职业字段',
          notes: '必须填写取消备注字段',
          tip: '小费不能为零',
          tipRepeat: '小费已存在。请输入新数字。',
          emailDontExist: '邮箱不存在。',
          ingredient: '配料已存在。'
        },
        permissionsGroup: {
          permissionMenu: '菜单权限',
          permissionCategory: '分类权限',
          permissionProduct: '商品权限',
          permissionSpecialPrice: '特价权限',
          permissionCustomer: '客户权限',
          permissionCredit: '信用权限',
          permissionHouseAccount: '内部账户权限',
          permissionTable: '餐桌权限',
          permissionTax: '税费权限',
          permissionShipping: '配送权限',
          permissionOtherCharge: '其他费用权限',
          permissionUser: '员工权限',
          permissionDriver: '司机监督权限',
          permissionDeliveryDriver: '配送司机权限',
          permissionOrder: '订单权限',
          permissionRole: '角色权限',
          permissionWorkSheet: '工作表权限',
          permissionSetting: '设置权限',
          permissionPayment: '支付权限',
          permissionReport: '报告权限',
          permissionClockin: '打卡权限',
          permissionOccupation: '职业权限',
          permissionVariantGroup: '选项权限',
          permissionReservation: '预订权限',
          permissionSuscriptors: '订阅者权限',
          permissionSuscription: '订阅权限',
          canViewMenu: '可以查看菜单',
          canCreateMenu: '可以创建菜单',
          canEditMenu: '可以编辑菜单',
          canDeleteMenu: '可以删除菜单',
          canViewCategory: '可以查看分类',
          canCreateCategory: '可以创建分类',
          canEditCategory: '可以编辑分类',
          canDeleteCategory: '可以删除分类',
          canViewProduct: '可以查看商品',
          canCreateProduct: '可以创建商品',
          canEditProduct: '可以编辑商品',
          canDeleteProduct: '可以删除商品',
          canViewSpecialPrices: '可以查看特价',
          canCreateSpecialPrices: '可以创建特价',
          canEditSpecialPrices: '可以编辑特价',
          canDeleteSpecialPrices: '可以删除特价',
          canViewCustomer: '可以查看客户',
          canCreateCustomer: '可以创建客户',
          canEditCustomer: '可以编辑客户',
          canDeleteCustomer: '可以删除客户',
          canViewCredit: '可以查看信用',
          canCreateCredit: '可以创建信用',
          canEditCredit: '可以编辑信用',
          canDeleteCredit: '可以删除信用',
          canViewHouseAccount: '可以查看内部账户',
          canCreateHouseAccount: '可以创建内部账户',
          canCreateSuscriptor: '可以创建订阅者',
          canViewSuscriptor: '可以查看订阅者',
          canEditSuscriptor: '可以编辑订阅者',
          canDesactivateSuscriptor: '可以停用订阅者',
          canViewTable: '可以查看餐桌',
          canCreateTable: '可以创建餐桌',
          canEditTable: '可以编辑餐桌',
          canDeleteTable: '可以删除餐桌',
          canViewTax: '可以查看税费',
          canCreateTax: '可以创建税费',
          canEditTax: '可以编辑税费',
          canDeleteTax: '可以删除税费',
          canViewShipping: '可以查看配送',
          canCreateShipping: '可以创建配送',
          canEditShipping: '可以编辑配送',
          canDeleteShipping: '可以删除配送',
          canViewOtherCharge: '可以查看其他费用',
          canCreateOtherCharge: '可以创建其他费用',
          canEditOtherCharge: '可以编辑其他费用',
          canDeleteOtherCharge: '可以删除其他费用',
          canViewUser: '可以查看用户',
          canCreateUser: '可以创建用户',
          canEditUser: '可以编辑用户',
          canDeleteUser: '可以删除用户',
          canViewDriver: '可以查看外部司机',
          canCreateDriver: '可以创建外部司机',
          canEditDriver: '可以编辑外部司机',
          canDeleteDriver: '可以删除外部司机',
          canViewDeliveryDriver: '可以查看配送司机',
          canEditDeliveryStatus: '可以编辑配送状态',
          canCreateDeliveryDriver: '可以创建配送司机',
          canDeleteDeliveryDriver: '可以删除配送司机',
          canViewOccupation: '可以查看职业',
          canCreateOccupation: '可以创建职业',
          canEditOccupation: '可以编辑职业',
          canDeleteOccupation: '可以删除职业',
          canViewRole: '可以查看角色',
          canCreateRole: '可以创建角色',
          canEditRole: '可以编辑角色',
          canDeleteRole: '可以删除角色',
          canViewWorkSheet: '可以查看工作表',
          canCreateWorkSheet: '可以创建工作表',
          canEditWorkSheet: '可以编辑工作表',
          canDeleteWorkSheet: '可以删除工作表',
          canViewOrder: '可以查看订单',
          canEditOrder: '可以编辑订单',
          canCreateOrder: '可以创建订单',
          canViewOrderForDelivery: '可以查看配送订单',
          canChangeSetting: '可以更改设置',
          canViewVariantGroup: '可以查看选项',
          canCreateVariantGroup: '可以创建选项',
          canEditVariantGroup: '可以编辑选项',
          canDeleteVariantGroup: '可以删除选项',
          canViewReservation: '可以查看预订',
          canCreateReservation: '可以创建预订',
          canEditReservation: '可以编辑预订',
          canDeleteReservation: '可以删除预订',
          canViewPayment: '可以查看支付',
          canIgnoreClockin: '可以忽略打卡',
          canViewSalesByCustomer: '可以查看按客户销售',
          canViewSalesByProduct: '可以查看按商品销售',
          canViewDynamicReports: '可以查看动态报告',
          canViewSubscription: '可以查看订阅',
          canCreateSubscription: '可以创建订阅',
          canEditSubscription: '可以编辑订阅',
          canDeleteSubscription: '可以删除订阅'
        },
        marketingMessages: {
          orderInfo: '订单信息',
          inKitchen: '，您好！感谢使用我们的服务。您的订单正在厨房处理中。',
          cooked: '您的订单已准备好。看起来很棒！',
          delivering: '您的订单正在配送中。请稍等片刻。',
          delivered: '您的订单已送达。祝您好胃口！',
          canceled: '您的订单已取消',
          cateringApproved: '，您的餐饮订单已批准。请查看您的邮箱以获取订单详情。',
          cateringCancel: '，抱歉，您的餐饮订单已取消。',
          reservationChangeStatus: '预订状态更改',
          reservationApproved: '，您好！您的预订已批准于',
            reservationApproved2: '，您现在需要确认预订。',
          reservationProposedDateTime:
            '，您好！很遗憾我们无法满足您要求的日期/时间。我们建议一个新的日期/时间：',
          reservationRejected:
            '，您好！很抱歉由于容量不足我们必须拒绝您的预订。',
          reservationCancel:
            '您的预订已取消。如果您有任何疑问，请随时联系我们。'
        },
      },
  },
  frontend:{
    menu: {
      clockInMessage: '您已成功打卡',
      signIn: '登录',
      chatImenu: 'iMenuApps® 技术支持',
      trackYourPackage: '追踪您的包裹',
      aboutImenu: '关于 iMenuapps®',
      seeLess: '收起',
      seeMore: '展开',
      foodAndMoodJournal: '饮食与心情日记',
      motivation: `要查看订单历史，请下载 iMenuApps® 应用并注册。
            <a href="https://apps.apple.com/us/app/imenuapps/id1574771438" target="_blank">在苹果应用商店下载</a> 或 
            <a href="https://play.google.com/store/apps/details?id=net.imenuapps.apps&hl=en_US&pli=1" target="_blank">在 Google Play 获取</a>。`,
      motivationMobile: '要查看订单历史，请注册 iMenuApps®。',
      menu: '菜单',
      shop: '商店',
      ads: '数字标牌',
      credit: '积分',
      menuCatering: '宴会菜单',
      pickupRequest: '取餐请求',
      termsOfUse: '使用条款',
      privacyPolicy: '隐私政策',
      otherPolicy: '其他政策',
      reservation: '预订',
      about: '关于我们',
      chat: '聊天',
      eMarkeeting: '电子营销',
      contact: '联系我们',
      oferts: '优惠',
      init: '首页',
      loginMerchant: '商家登录',
      loginClient: '客户登录',
      editProfile: '编辑个人资料',
      edit: '修改资料',
      log: '登录 / 注册',
      membersLogin:'会员登录',
      membersRegister: '会员注册',
      merchantsLogin:'商家登录',
      catering: '宴会服务',
      logout: '退出登录',
      logIn: '登录',
      profil: '我的账户',
      profil1: '个人资料',
      createUser: '注册',
      forgotPassword: '忘记密码？',
      passwordReset: '重置密码',
      newPassword: '新密码',
      newData: '修改资料',
      confirmPassword: '确认密码',
      register: '注册',
      orders: '订单',
      restaurant: '点击下方选择商家类型',
      restablacerPassword: '重置密码',
      updateData: '更新资料',
      mssForgotPassword: '我们已发送新密码至您的邮箱。',
      errorLogIn: '邮箱或密码错误',
      errEmailExist: '该邮箱已存在',
      errPassNotCoinc: '与新密码不匹配',
      userNotFound: '邮箱错误',
      refresh: '刷新',
      mssUpdateData: '资料更新成功',
      mssCreateUser: '客户创建成功，新密码已发送至您的邮箱。',
      mssPasswordChangedCorrectly: '密码更新成功',
      ticketMenu: '创建工单'
    },
    app: {
      convertToProd: '试用版转正式版',
      convert: '转换',
      daysOfTrial: '试用天数',
      trialExpired: '试用已到期',
      trialMessageExpired: '您的 iMenuApps® 免费试用已结束。如需继续使用完整功能，请购买许可证。请发送邮件至 support@imenuapps.com 并提供您的商家名称。',
      allBusiness: '所有商家',
      hospitality: '餐饮住宿',
      reservations: '预订',
      service: '服务',
      entertainment: '娱乐',
      retail: '零售',
      fullText: 'iMenuApps® 为您提供一体化商业解决方案，配备增强型客户门户。我们的平台不仅能帮助企业优化运营、提升销售，还通过先进的客户门户提升用户体验。客户可轻松重复订购商品服务，并完整记录与平台上每个商家的交易和档案。无论您从事餐饮住宿、零售、服务还是娱乐行业，iMenuApps® 都能满足您的特定需求。'
    },
    product: {
      title: '商品列表',
      back: '返回',
      noProducts: "抱歉！此分类暂无商品。",
      productDetail: '商品详情',
      massageToast: '操作成功',
      productNote: '在此输入商品备注...',
      productWithVariant: '点击"添加"选择其他选项'
    },
    home: {
      country: '国家',
      stateProvince: '州/省/地区',
      county: '县',
      autocomplete: '在此输入地址以自动填充',
      selectCategory: '菜单分类',
      cardTitle: '购物车详情',
      cardheader: '商品',
      cancel: '取消',
      acept: '确定',
      confirm: '确认',
      clear: '清空',
      checkout: '结账',
      deliverDetail: '配送详情',
      address: '地址',
      pickupDetail: '自取详情',
      curbsideDetail: '路边取货详情',
      cateringDate: '宴会日期',
      pickTime: '当前自取时间不可用，请选择其他时间',
      tableQr: '座位二维码',
      notValidQr: '无效二维码',
      notSeatAvailable: '该座位已被占用',
      errorRequired: '请填写必填信息',
      errorDateNotValid: '日期无效',
      noProductForReorder: '没有可重复订购的商品。',
      noProductAvailable: '以下商品因今日无货未显示在订单中。',
      clientRequired: '此操作仅限注册用户，请登录。',
      cantNotValid: '商品数量无效',
      zipCodeNotValid: '邮政编码无效',
      notZoneToDeliver: '当前区域不支持配送',
      state: '州',
      city: '城市',
      notValidEmail: '邮箱格式错误',
      reqSuccess: '变更请求提交成功！',
      approveSuccess: '变更请求批准成功！',
      alertDeleteData: '确定要重新开始吗？',
      notTimeToPick: '自取时间范围为: ',
      cookTime: '预计烹饪时间 ',
      priceEstimated: '预估价格',
      minuts: ' 分钟。',
      selectOrderType: '请选择订单类型。',
      search: '搜索',
      aggregateFree: '免费添加',
      sides: '配菜',
      choises: '配料',
      variants: '变体',
      withoutIngredients: '不含配料',
      eventType: '活动类型',
      emailSended: '邮件已发送',
      choseView: '可选视图',
      applicationCreateSuccess: '应用创建成功',
      applicationCreateError: '创建应用时出错'
    },
    // 其他部分按相同模式继续翻译...
    genderOptions: {
      male: '男',
      female: '女',
      nonBinary: '非二元性别',
      transgenderMale: '跨性别男性',
      transgenderFemale: '跨性别女性',
      genderqueer: '性别酷儿',
      genderfluid: '流性人',
      agender: '无性别',
      twoSpirit: '双灵',
      bigender: '双性别',
      demiboy: '半男孩',
      demigirl: '半女孩',
      androgynous: '中性',
      intersex: '间性人',
      neutrois: '无性别认同',
      pangender: '泛性别',
      polygender: '多性别',
      preferNotToSay: '不愿透露',
      other: '其他'
    },
    orderType: {
      customerType: '客户类型',
      lastContacted: '最后联系时间',
      nextFollowUp: '下次跟进时间',
      preferredContactTime: '首选联系开始时间',
      preferredContactToTime: '首选联系结束时间',
      order: '订单',
      invoice: '发票',
      quote: '报价单',
      email: '邮箱',
      password: '密码',
      emailPhone: '邮箱和电话',
      name: '姓名',
      phone: '电话',
      address: '地址',
      code: '邮政编码',
      pickDate: '自取日期',
      pickOut: '自取时间',
      licencePlate: '车牌号',
      vehicleModel: '车辆品牌/型号',
      vehicleColor: '车辆颜色',
      contactedBy: '联系方式',
      tellContact: '请告知最佳联系途径',
      worker: '员工',
      minAmountDelivery: '宴会最低配送金额',
      minAmountPickUp: '宴会最低自取金额'
    },
    reservation: {
      availability: '每周可预订时间',
      reservations: '预订',
      reservationDetail: '预订详情',
      create: '新建预订',
      reservationDate: '预订日期',
      reservationHour: '预订时间',
      timezone: '时区',
      peoples: '人数',
      serviceTime: '预计服务时间',
      reason: '事由',
      find: '搜索预订',
      enterCode: '输入预订码',
      yoursReservations: '我的预订',
      code: '预订码',
      completeDateReservacion: '日期',
      notcodefind: '未找到与该预订码关联的预订',
      state0: '申请中',
      state1: '已批准',
      state2: '建议日期/时间',
      state3: '已拒绝',
      state4: '已确认',
      state5: '已取消',
      state6: '已完成',
      Monday: '周一',
      Tuesday: '周二',
      Wednesday: '周三',
      Thursday: '周四',
      Friday: '周五',
      Saturday: '周六',
      Sunday: '周日',
      all: '全部',
      restaurantHour: '营业时间',
      open: '营业中',
      close: '已打烊，继续访问页面',
      errorHourCaterin: '宴会预订时间为 ',
      errorHour: '预订时间为 ',
      errorHour2: ' 至 ',
      discount: '折扣',
      orderCloseToDiscount: "该预订已关闭，无法使用此报价支付。",
      subtotalNotForDiscount: "订单金额未达折扣条件，无法使用此报价支付。",
      notDiscountToApply: '无可用折扣',
      restaurantNotes: '商家备注',
      quotationMessage1: '我们的预付餐费为 ',
      quotationMessage2: '此金额将在您下单时抵扣。',
      dinnerPrePayment: '餐费预付',
      timeToReserve: '预订时长(分钟)',
      available: '可预订',
      notAvailable: '不可预订',
      deposit: '预订押金',
      seatsAvailable: ' 个可用座位',
      guestLocation: '选择所有宾客的位置',
      notGuestAvaibility: '您的宾客人数超出可接待范围',
      selectStaff: '选择服务人员'
    },
    order: {
      item: '商品',
      description: '描述',
      quantity: '数量',
      taxable: '需缴税?',
      amount: '金额',
      tip: '小费',
      discount: '折扣',
      creditCardFee: '信用卡手续费',
      shipping: '运费',
      trackShipping: "追蹤運輸",
      packagesManagement: '软件包管理',
      tax: '税费',
      deposit: '押金',
      pendingAcceptance: '待接受',
      accepted: '已接受',
      prepare: '准备中',
      email: '电子邮箱',
      phone: '电话',
      goBack: '返回',
      orderDetail: '订单详情',
      quoteDetail: '报价详情',
      convertInvoice: '转为发票',
      aceptQuote: '接受报价',
      productServicesUpdated: '商品/服务已更新',
      payInvoive: '支付发票',
      invoiceDetail: '发票详情',
      invoiceNumber: '发票编号',
      invoiceTerm: '条款',
      invoicePayed: '您的发票已支付',
      shippingDate: '发货日期',
      shippingVia: '运输方式',
      shippingTo: '收货地址',
      shippingFrom: '发货地址',
      shippingTrackingNumber: '物流单号',
      client: '客户',
      cart: '购物车',
      productsOrdered: '已订购商品',
      products: '商品',
      name: '名称',
      cant: '数量',
      price: '单价',
      total: '总计',
      otherCharges: '其他费用',
      quotationPayment: '报价支付',
      cashPayment: '现金支付',
      isTicket: '作为工单开启订单',
      payAsTicket: '授权支付',
      sendInvoice: '发送发票',
      saveAsTicket: '保存工单',
      checkPayment: '支票支付',
      parcialPayment: '部分支付',
      quotationMessage1: '我们的报价费为 ',
      quotationMessage2: '此金额将在您下单时抵扣。',
      pendingPayment: '待支付',
      subtotal: '小计',
      taxe: '税费',
      deliver: '配送费',
      tip: '小费',
      notes: '备注',
      payment: '支付详情',
      ccard: '信用卡',
      ccode: '安全码',
      payWithThisCardQuestion: '您想用这张卡付款吗？',
      cardEndingIn: '卡号以以下数字结尾',
      yesPayNow: '是的，立即付款',
      paymentSuccessful: '支付成功',
      paymentProcessed: '您的付款已成功处理',
      expcard: '有效期',
      dueDate: '到期日',
      pay: '支付',
      verify: '验证支付',
      transictionTitle: '交易状态',
      transictionOk: '交易成功',
      sendRequest: '发送请求',
      requestCatering: '请求已发送，商家将尽快与您联系。',
      transictionError: '支付执行错误',
      notValidCC: '信用卡号无效',
      yourOrders: '订单',
      yourTicket: '工单',
      seeAll: '查看所有订单',
      orderState: '订单状态',
      cooker: '厨师',
      type: '类型',
      state: '状态',
      messageToast: "注册即可追踪订单并查看历史订单，操作简单！",
      messgForContact: "注册即可追踪订单并查看历史订单，操作简单！",
      messgForContactCatering: '需登录才能创建宴会订单',
      date: '日期',
      state0: '待支付',
      state1: '已支付',
      state2: '厨房处理中',
      state3: '已备好',
      state4: '配送中',
      state5: '已送达',
      state6: '已取消',
      state7: '待审核',
      state8: '宴会已批准',
      state9: '报价单',
      state10: '已自取',
      state11: '已延迟',
      state12: '作废中',
      state13: '已退款',
      notOrder: '您没有待处理订单',
      transId: '交易号',
      invoice: '发票',
      invoiceProposal: '发票提案',
      invoiceProposalUpdated: '发票提案已更新',
      add: '添加',
      share: '分享',
      remove: '移除',
      edit: '编辑',
      cancelReason: '取消原因',
      paymentMethod: '支付方式',
      orderFor: '订单接收人',
      other: '其他',
      noTip: '无小费',
      payed: '已支付',
      toPay: '待支付',
      readyForPick: '订单备好后您将收到短信或邮件通知。',
      location: '位置',
      hourToPickEstimated: '预计自取时间',
      dateToPickEstimated: '预计自取日期',
      routingNumber: '银行路由号码',
      accountNumber: '账号',
      bankName: '银行名称',
      badroutingNumber: '银行路由号码错误',
      eventName: '活动名称',
      guessNumber: '宾客人数',
      eventDate: '活动日期',
      messageDevice: '请联系 iMenuApps® 技术支持添加设备 电话:973-969-1909 或邮箱:support@solutionsforsuccess.net',
      eventStartHour: '活动开始时间',
      eventEndHour: '活动结束时间',
      warningProductsTheOrderToCatering: '您正在添加非宴会服务的商品。继续操作将清空之前添加的商品。',
      warningProductsTheCateringToOrder: '您正在添加宴会服务商品。继续操作将清空之前添加的商品。',
      clientInfo: '客户信息',
      orderType: '订单类型',
      paymentByCard: '信用卡支付',
      totalForPay: '应付总额',
      firstName: '名',
      lastName: '姓',
      postalCode: '邮编',
      addressLine1: '地址',
      updateTicket: '更新工单',
      closeTicket: '关闭工单',
      closed: '已关闭',
      requiredCustomer: '客户资料',
      requiredOrderType: '订单类型',
      culumnNumber: '行内列数'
    },
    tooltips: {
      addOrder: '添加',
      printOrder: '打印',
      forward: '转发',
      reOrder: '重新订购',
      refreshOrder: '刷新',
      refreshCaptcha: '刷新验证码',
      deleteOrder: '删除',
      readyProduct: '已备好',
      printRes: '打印',
      shareLocation: '分享位置',
      closeTicket: '关闭',
      editTicket: '编辑',
      loadInfo: '正在加载您的数据',
      loadRestaurant: '加载中...',
      getToRestaurant: '到达商家位置后点击此处',
      carInRestaurant: '车辆已到达商家',
      carArrivedInfo: '感谢您告知车辆已到达',
      errorRestaurantOffline: '该商家未对外开放',
      deliveryPayment: '配送支付'
    },
    payment: {
      splitPayment: '分账支付',
      splitIn: '分成',
      splitMss: '支付金额必须覆盖订单总额, 每笔支付不可为0',
      splitPay: '支付#',
      splitToPay: '支付',
      splitPayed: '已支付',
      tjtPayment: '信用卡',
      creditPayment: '信用支付',
      devicePayment: '设备支付',
      idtechPayment: 'MOTO/刷卡',
      swipePayment: '刷卡',
      cashPayment: '现金',
      hcaPayment: 'ACH支付',
      housePayment: '内部账户',
      checkPayment: '支票',
      sharePayment: '共享支付',
      qrPayment: '二维码支付',
      verifyMss: '确认支付完成后请验证以保存订单，或取消终止本次支付。',
      doingPayment: '支付中',
      authorizingPayment: '授权支付中',
      insuficientFunds: '余额不足',
      quoteExpired: '抱歉，该报价已过期',
      quoteChanged: '报价已修改，当前状态为',
      quoteAcepted: '报价已接受',
      goodPayment: '已支付',
      shareText1: '分享了在商家 ',
      shareText1a: '分享了在商家 ',
      shareText2: ' 的支付链接，请点击下方链接完成支付。谢谢！'
    },
    createNew: {
      businessTemplate: '商家模板',
      restaurantName: '商家名称',
      restaurantAddres: '商家地址',
      restaurantPhone: '商家电话',
      restaurantEmail: '商家邮箱',
      restaurantZipcode: '商家邮编',
      restaurantWeb: '商家网站',
      restaurantFax: '商家传真',
      merchantName: '商户名',
      merchantLastName: "商户姓",
      merchantAddres: '商户地址',
      merchantZipcode: '邮编',
      merchantPhone: '商户电话',
      merchantEmail: '商户邮箱',
      merchantClerk: '用户PIN码(1-99999)',
      createTitle: '在iMenuApps®创建新商家',
      dataRestaurant: '商家详情',
      dataMercahnt: '商户资料',
      restaurants: '商家',
      createdMessage: '商家创建成功，登录密码将发送至您的邮箱',
      clerkToLong: 'PIN码超过最大值99999',
      clerkNotValid: '无效PIN码',
      reciveSubscription: '您希望接收来自',
      activateSubscription: '您希望为以下商家激活通知',
      saving: '保存商家信息中',
      recordSaving: '保存中',
      active: '激活',
      inactive: '未激活',
      restaurantType: '商家类型',
      template: '模板',
      chooseBusinessTemplate: '选择商家模板',
      select: '选择',
      temrsAndCondition: '条款与条件',
      trialDate: '天试用期',
      trialMss: '14天免费试用',
      business: '商家',
      reservation: '预订'
    },
    unsubscribe: {
      title: '退订',
      email: '邮箱',
      unsubscribeOk: '退订成功',
      unsubscribeFail: '错误，邮箱未找到',
      restaurantFail: '商家未找到'
    },
    specialsPrice: {
      titles: '特价活动',
      title: '特价',
      name: '名称',
      type: '类型',
      amount: '金额',
      for: '适用对象',
      apply: '应用',
      active: '激活',
      repite: '重复',
      oneStarDate: '开始日期时间',
      oneEndDate: '结束日期时间',
      weekStarDate: '开始时间',
      weekEndDate: '结束时间',
      monthStardDat: '每月日期',
      annualStartDat: '每年月日',
      activeRule: '同一时间仅会应用一个规则，优先激活的规则将生效。'
    },
    credit: {
      state0: '已申请',
      state1: '已接受',
      state2: '已取消',
      state3: '已完成',
      yourCredit: '您的信用额度',
      amount: '信用金额',
      debt: '欠款',
      createDate: '创建日期',
      active: '激活',
      dateFrom: '开始日期',
      dateTo: '结束日期',
      paymentDate: '支付日期',
      state: '状态',
      pendingPay: '待支付',
      payed: '已支付',
      creditpayed: '信用支付',
      mssPay1: '客户 ',
      mssPay2: '已完成信用支付 ',
      mssPay3: '金额为 '
    }
  }
}
